import image1 from "../../../assets/Images/1.jpg";

// Guides profile pic
import fatima from "../../../assets/Images/Guides/Fatima.jpg";
import haval from "../../../assets/Images/Guides/Haval.png";
import harbi from "../../../assets/Images/Guides/Harbi.png";
import nuha from "../../../assets/Images/Guides/Nuha.webp";
import yousif from "../../../assets/Images/Guides/Yousif.png";
import aliH from "../../../assets/Images/Guides/AliHameed.png";
import lubna from "../../../assets/Images/Guides/Lubna.png";
import hussein from "../../../assets/Images/Guides/Hussein Rashid.png";

// Guides Cover
import sky from "../../../assets/Images/Guides/CoverPhoto/Sky.jpeg";
import camping from "../../../assets/Images/Guides/CoverPhoto/camping.jpeg";
import basrah from "../../../assets/Images/Guides/CoverPhoto/Basrah.jpeg";
import baghdad from "../../../assets/Images/Guides/CoverPhoto/Baghdad.jpeg";
import karbala from "../../../assets/Images/Guides/CoverPhoto/Karbala.jpeg";
import najaf from "../../../assets/Images/Guides/CoverPhoto/Najaf.jpeg";
import kurdistan from "../../../assets/Images/Guides/CoverPhoto/Kurdistan.jpeg";
import anbar from "../../../assets/Images/Guides/CoverPhoto/Anbar.jpeg";

const GuideData = [
	// 1 Fatima
	{
		idGuide: 1,
		image: fatima,
		imgCover: sky,
		name: "فاطمة احمد",
		province: "بغداد",
		perHour: "20",
		rate: 4,
		noOfReviews: 15,
		Quote: "متحمسة لمساعدة الآخرين في تحقيق أهدافهم",
		ProgramsData: [
			{
				id: 101,
				image: image1,
				name: "رمال بلاد ما بين النهرين",
				describe:
					"استكشاف المناظر الصحراوية القديمة وعجائب بلاد ما بين النهرين الأثري",
				cost: 370,
				duration: 3,
				startDate: "1705698000",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"يعد اليوم الثاني تجربة ثقافية غامرة بينما تستمر رحلتك في عجائب ما بين النهرين التاريخية.",
							"المشاركة في أنشطة ثقافية متنوعة وتجارب، مكتسبة رؤى حول تقاليد المنطقة.",
							"هذا اليوم فرصة للتواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"في اليوم النهائي من مغامرتك، استكشف أي مواقع أثرية متبقية، مضمنًا جوهر المناظر الصحراوية.",
							"تخصيص وقت تقدير الجمال الذي تقدمه بلاد ما بين النهرين.",
							"تختتم الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"بعد ذلك، انطلق في رحلتك التالية، حاملًا ذكريات بلاد ما بين النهرين معك.",
						],
					},
				},
			},
			{
				id: 102,
				image: image1,
				name: "مسار اكتشاف كوردستان",
				describe:
					"انغمس في الثقافة الغنية والمناظر الطبيعية الرائعة لإقليم كوردستان",
				cost: 400,
				duration: 4,
				startDate: "1703538000",
				schedule: {
					day1: {
						title: "الوصول والتعريف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف منطقة كوردستان.",
							"التمتع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "التغمر الثقافي",
						activities: [
							"مواصلة الرحلة من خلال عجائب التاريخ.",
							"المشاركة في أنشطة وتجارب ثقافية.",
							"التواصل مع المجتمعات المحلية والتعرف على تقاليدها.",
						],
					},
					day3: {
						title: "الطبيعة والمغامرة",
						activities: [
							"استكشاف الجمال الطبيعي لمناظر كوردستان.",
							"المشاركة في الأنشطة والمغامرات في الهواء الطلق.",
							"التمتع بالتنوع البيئي الفريد وثقافة المجتمع المحلي النابضة بالحياة.",
						],
					},
					day4: {
						title: "وداعًا والرحيل",
						activities: [
							"انهاء مغامرتك بفعالية وداع.",
							"الرحيل في رحلتك التالية مع ذكريات عزيزة لمسار اكتشاف كوردستان.",
						],
					},
				},
			},
			{
				id: 103,
				image: image1,
				name: "بعثة تراث بغداد",
				describe:
					"اكتشاف الكنوز التاريخية والثقافة النابضة لعاصمة العراق",
				cost: 200,
				duration: 4,
				startDate: "1644008400",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"مواصلة رحلتك من خلال عجائب التاريخ في بلاد ما بين النهرين.",
							"المشاركة في أنشطة ثقافية وتجارب متنوعة.",
							"التواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"استكشاف أي مواقع أثرية متبقية، ملتقطًا جوهر المناظر الصحراوية.",
							"اخذ وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"اختتام الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"الرحيل في رحلتك التالية، حاملًا معك ذكريات بلاد ما بين النهرين.",
						],
					},
					day4: {
						title: "الرحيل",
						activities: [
							"التسجيل من مكان الإقامة الخاص بك.",
							"التأمل في التجارب والذكريات التي تم إنشاؤها خلال الرحلة.",
							"الرحيل في رحلتك التالية.",
						],
					},
				},
			},
			{
				id: 104,
				image: image1,
				name: "ملاذ هدوء الأهوار",
				describe:
					"انغمس في جمال السكون في أهوار العراق، واستمتع بتجربة النظام البيئي الفريد والثقافة المحلية النابضة بالحياة",
				cost: 200,
				duration: 2,
				startDate: "1707080400",
				schedule: {
					day1: {
						title: "الوصول والتغمر في الطبيعة",
						activities: [
							"الوصول إلى موقع الملاذ الهادئ المحاط بالأهوار.",
							"تسجيل الوصول إلى إقامتك المريحة.",
							"انغمس في الطبيعة مع جولة موجهة عبر الأهوار.",
							"المشاركة في جلسة تأمل للاسترخاء والاسترخاء.",
							"الاستمتاع بعشاء لذيذ محضر بنكهات محلية.",
						],
					},
					day2: {
						title: "العافية والرحيل",
						activities: [
							"ابدأ يومك بجلسة يوغا مجددة بجوار الأهوار.",
							"تناول وجبة إفطار مغذية لبدء يومك.",
							"تجربة جلسة سبا أو تدليك للاسترخاء النهائي.",
							"المشاركة في ورشة عمل لتصوير الطبيعة أو نشاط مشاهدة الطيور.",
							"اختتم إقامتك بالغداء الصحي.",
							"التسجيل والرحيل برغم الهدوء والروح المنعشة.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 1001,
				userName: "ديفيد جونسون",
				userGuideRate: 4,
				comment:
					"قدمت فاطمة رحلة فريدة ومفيدة في العراق. كانت هذه الرحلة ذات معرفة ودية، وجعلت التجربة فريدة من نوعها. أنصح بشدة بخدماتها.",
			},
			{
				userId: 1002,
				userName: "إيما ديفيس",
				userGuideRate: 5,
				comment:
					"جعلت فاطمة توجيه زيارتي إلى العراق استثنائية. المعرفة العميقة بالثقافة والتاريخ، جنبًا إلى جنب مع السعة الدافئة والودودة، خلقت تجربة لا تنسى. أنا ممتن لخبرة فاطمة وأوصي بها بشدة كمرشد.",
			},
			{
				userId: 1003,
				userName: "مايكل سميث",
				userGuideRate: 3,
				comment:
					"كانت فاطمة مرشدنا خلال رحلتنا إلى العراق. على الرغم من أن الرحلة كانت مثيرة للاهتمام، يمكن تحسين مهارات التواصل والتنظيم لديها. على الرغم من بعض العثرات، قدرنا الجهود والرؤى في الحياة المحلية.",
			},
			{
				userId: 1004,
				userName: "مايكل سميث",
				userGuideRate: 3,
				comment:
					"كانت فاطمة مرشدنا خلال رحلتنا إلى العراق. على الرغم من أن الرحلة كانت مثيرة للاهتمام، يمكن تحسين مهارات التواصل والتنظيم لديها. على الرغم من بعض العثرات، قدرنا الجهود والرؤى في الحياة المحلية.",
			},
		],
		GuideInfo: [
			{
				title: "سأري لك",
				description:
					"ستستكشف الجواهر الخفية والمعالم الرمزية، وتستمتع بالمأكولات العراقية التقليدية، وتشارك في المهرجانات الثقافية معي",
			},
			{
				title: "عني",
				description: `مرحبًا، أنا فاطمة، مرشدك إلى شوارع بغداد الحيوية. استعد لرحلة لا تُنسى مليئة بالتاريخ الغني واللذائذ الثقافية`,
			},
			{
				title: "اللغات",
				description: ["العربية", "، الإنجليزية"],
			},
			{
				title: "الأنشطة",
				description: [
					"جولات تاريخية",
					"، مغامرات في الطهي",
					"، استكشاف الأسواق",
					"، المهرجانات المحلية",
				],
			},
		],
	},
	// 2 Haval
	{
		idGuide: 2,
		image: haval,
		imgCover: camping,
		name: "هافال",
		province: " اربيل ",
		perHour: 60,
		rate: 5,
		noOfReviews: 10,
		Quote: "هنا العراق حيث يتجلى التاريخ في كل خطوة تخطوها",

		ProgramsData: [
			{
				id: 201,
				image: image1,
				name: "رمال بلاد ما بين النهرين",
				describe:
					"استكشاف المناظر الصحراوية القديمة وعجائب بلاد ما بين النهرين الأثري",
				cost: 370,
				duration: 3,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"يعد اليوم الثاني تجربة ثقافية غامرة بينما تستمر رحلتك في عجائب ما بين النهرين التاريخية.",
							"المشاركة في أنشطة ثقافية متنوعة وتجارب، مكتسبة رؤى حول تقاليد المنطقة.",
							"هذا اليوم فرصة للتواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"في اليوم النهائي من مغامرتك، استكشف أي مواقع أثرية متبقية، مضمنًا جوهر المناظر الصحراوية.",
							"تخصيص وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"تختتم الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"بعد ذلك، انطلق في رحلتك التالية، حاملًا ذكريات بلاد ما بين النهرين معك.",
						],
					},
				},
			},
			{
				id: 202,
				image: image1,
				name: "مسار اكتشاف كوردستان",
				describe:
					"انغمس في الثقافة الغنية والمناظر الطبيعية الرائعة لإقليم كوردستان",
				cost: 400,
				duration: 4,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "الوصول والتعريف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف منطقة كوردستان.",
							"التمتع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "التغمر الثقافي",
						activities: [
							"مواصلة الرحلة من خلال عجائب التاريخ.",
							"المشاركة في أنشطة وتجارب ثقافية.",
							"التواصل مع المجتمعات المحلية والتعرف على تقاليدها.",
						],
					},
					day3: {
						title: "الطبيعة والمغامرة",
						activities: [
							"استكشاف الجمال الطبيعي لمناظر كوردستان.",
							"المشاركة في الأنشطة والمغامرات في الهواء الطلق.",
							"التمتع بالتنوع البيئي الفريد وثقافة المجتمع المحلي النابضة بالحياة.",
						],
					},
					day4: {
						title: "وداعًا والرحيل",
						activities: [
							"انهاء مغامرتك بفعالية وداع.",
							"الرحيل في رحلتك التالية مع ذكريات عزيزة لمسار اكتشاف كوردستان.",
						],
					},
				},
			},
			{
				id: 203,
				image: image1,
				name: "بعثة تراث بغداد",
				describe:
					"اكتشاف الكنوز التاريخية والثقافة النابضة لعاصمة العراق",
				cost: 200,
				duration: 4,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"مواصلة رحلتك من خلال عجائب التاريخ في بلاد ما بين النهرين.",
							"المشاركة في أنشطة ثقافية وتجارب متنوعة.",
							"التواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"استكشاف أي مواقع أثرية متبقية، ملتقطًا جوهر المناظر الصحراوية.",
							"اخذ وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"اختتام الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"الرحيل في رحلتك التالية، حاملًا معك ذكريات بلاد ما بين النهرين.",
						],
					},
					day4: {
						title: "الرحيل",
						activities: [
							"التسجيل من مكان الإقامة الخاص بك.",
							"التأمل في التجارب والذكريات التي تم إنشاؤها خلال الرحلة.",
							"الرحيل في رحلتك التالية.",
						],
					},
				},
			},
			{
				id: 204,
				image: image1,
				name: "ملاذ هدوء الأهوار",
				describe:
					"انغمس في جمال السكون في أهوار العراق، واستمتع بتجربة النظام البيئي الفريد والثقافة المحلية النابضة بالحياة",
				cost: 200,
				duration: 2,
				startDate: "1734296400",
				schedule: {
					day1: {
						title: "الوصول والتغمر في الطبيعة",
						activities: [
							"الوصول إلى موقع الملاذ الهادئ المحاط بالأهوار.",
							"تسجيل الوصول إلى إقامتك المريحة.",
							"انغمس في الطبيعة مع جولة موجهة عبر الأهوار.",
							"المشاركة في جلسة تأمل للاسترخاء والاسترخاء.",
							"الاستمتاع بعشاء لذيذ محضر بنكهات محلية.",
						],
					},
					day2: {
						title: "العافية والرحيل",
						activities: [
							"ابدأ يومك بجلسة يوغا مجددة بجوار الأهوار.",
							"تناول وجبة إفطار مغذية لبدء يومك.",
							"تجربة جلسة سبا أو تدليك للاسترخاء النهائي.",
							"المشاركة في ورشة عمل لتصوير الطبيعة أو نشاط مشاهدة الطيور.",
							"اختتم إقامتك بالغداء الصحي.",
							"التسجيل والرحيل برغم الهدوء والروح المنعشة.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 2001,
				userName: "ديفيد جونسون",
				userGuideRate: 4,
				comment:
					"هافال قدم رحلة فريدة ومثيرة عبر العراق. كان هذا الدليل متعلمًا وودودًا، وجعل التجربة فعلاً خاصة. أوصي بشدة بخدماته",
			},
			{
				userId: 2002,
				userName: "ايمي ديفيس",
				userGuideRate: 5,
				comment:
					"إرشاد هافال جعل زيارتي إلى العراق استثنائية. المعرفة العميقة بالثقافة والتاريخ، بالإضافة إلى السعة الدافئة والودودة، خلقت تجربة لا تُنسى. أنا ممتن لخبرة هافال وأوصي به بشدة كدليل.",
			},
			{
				userId: 2003,
				userName: "مايكل سميث",
				userGuideRate: 3,
				comment:
					"كان هافال مرشدنا خلال رحلتنا إلى العراق. على الرغم من أن الرحلة كانت مثيرة، إلا أن مهارات التواصل والتنظيم لديه يمكن تحسينها. على الرغم من بعض التحديات، قدرنا الجهود والتحليلات التي قدمها حول الحياة المحلية.",
			},
			{
				userId: 2003,
				userName: "مايكل سميث",
				userGuideRate: 3,
				comment:
					"كان هافال مرشدنا خلال رحلتنا إلى العراق. على الرغم من أن الرحلة كانت مثيرة، إلا أن مهارات التواصل والتنظيم لديه يمكن تحسينها. على الرغم من بعض التحديات، قدرنا الجهود والتحليلات التي قدمها حول الحياة المحلية.",
			},
		],
		GuideInfo: [
			{
				title: "سأري لك",
				description:
					"ستستكشف الجواهر الخفية والمعالم الرمزية، وتستمتع بالمأكولات العراقية التقليدية، وتشارك في المهرجانات الثقافية معي",
			},
			{
				title: "عني",
				description: `مرحبًا، أنا هفال، مرشدك إلى شوارع إربيل الحيوية. استعد لرحلة لا تُنسى مليئة بالتاريخ الغني واللذائذ الثقافية`,
			},
			{
				title: "اللغات",
				description: [
					"العربية",
					"، الكردية",
					"، الإنجليزية",
				],
			},
			{
				title: "الأنشطة",
				description: [
					"رياضة المشي",
					"، مغامرات في الطهي",
					"، استكشاف الأسواق",
					"، المهرجانات المحلية",
					"، التخييم",
				],
			},
		],
	},
	// 3 Harbi
	{
		idGuide: 3,
		image: harbi,
		imgCover: basrah,
		name: "حربي عادل",
		province: "البصرة ",
		perHour: 30,
		rate: 5,
		noOfReviews: 5,
		Quote: "استكشف مهد الحضارة، وتأسس بروح العراق",
		ProgramsData: [
			{
				id: 301,
				image: image1,
				name: "رمال بلاد ما بين النهرين",
				describe:
					"استكشاف المناظر الصحراوية القديمة وعجائب بلاد ما بين النهرين الأثري",
				cost: 370,
				duration: 3,
				startDate: "1703019600",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"يعد اليوم الثاني تجربة ثقافية غامرة بينما تستمر رحلتك في عجائب ما بين النهرين التاريخية.",
							"المشاركة في أنشطة ثقافية متنوعة وتجارب، مكتسبة رؤى حول تقاليد المنطقة.",
							"هذا اليوم فرصة للتواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"في اليوم النهائي من مغامرتك، استكشف أي مواقع أثرية متبقية، مضمنًا جوهر المناظر الصحراوية.",
							"تخصيص وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"تختتم الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"بعد ذلك، انطلق في رحلتك التالية، حاملًا ذكريات بلاد ما بين النهرين معك.",
						],
					},
				},
			},
			{
				id: 302,
				image: image1,
				name: "مسار اكتشاف كوردستان",
				describe:
					"انغمس في الثقافة الغنية والمناظر الطبيعية الرائعة لإقليم كوردستان",
				cost: 400,
				duration: 4,
				startDate: "1729026000",
				schedule: {
					day1: {
						title: "الوصول والتعريف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف منطقة كوردستان.",
							"التمتع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "التغمر الثقافي",
						activities: [
							"مواصلة الرحلة من خلال عجائب التاريخ.",
							"المشاركة في أنشطة وتجارب ثقافية.",
							"التواصل مع المجتمعات المحلية والتعرف على تقاليدها.",
						],
					},
					day3: {
						title: "الطبيعة والمغامرة",
						activities: [
							"استكشاف الجمال الطبيعي لمناظر كوردستان.",
							"المشاركة في الأنشطة والمغامرات في الهواء الطلق.",
							"التمتع بالتنوع البيئي الفريد وثقافة المجتمع المحلي النابضة بالحياة.",
						],
					},
					day4: {
						title: "وداعًا والرحيل",
						activities: [
							"انهاء مغامرتك بفعالية وداع.",
							"الرحيل في رحلتك التالية مع ذكريات عزيزة لمسار اكتشاف كوردستان.",
						],
					},
				},
			},
			{
				id: 303,
				image: image1,
				name: "بعثة تراث بغداد",
				describe:
					"اكتشاف الكنوز التاريخية والثقافة النابضة لعاصمة العراق",
				cost: 200,
				duration: 4,
				startDate: "1733173200",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"مواصلة رحلتك من خلال عجائب التاريخ في بلاد ما بين النهرين.",
							"المشاركة في أنشطة ثقافية وتجارب متنوعة.",
							"التواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"استكشاف أي مواقع أثرية متبقية، ملتقطًا جوهر المناظر الصحراوية.",
							"اخذ وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"اختتام الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"الرحيل في رحلتك التالية، حاملًا معك ذكريات بلاد ما بين النهرين.",
						],
					},
					day4: {
						title: "الرحيل",
						activities: [
							"التسجيل من مكان الإقامة الخاص بك.",
							"التأمل في التجارب والذكريات التي تم إنشاؤها خلال الرحلة.",
							"الرحيل في رحلتك التالية.",
						],
					},
				},
			},
			{
				id: 304,
				image: image1,
				name: "ملاذ هدوء الأهوار",
				describe:
					"انغمس في جمال السكون في أهوار العراق، واستمتع بتجربة النظام البيئي الفريد والثقافة المحلية النابضة بالحياة",
				cost: 200,
				duration: 2,
				startDate: "1681938000",
				schedule: {
					day1: {
						title: "الوصول والتغمر في الطبيعة",
						activities: [
							"الوصول إلى موقع الملاذ الهادئ المحاط بالأهوار.",
							"تسجيل الوصول إلى إقامتك المريحة.",
							"انغمس في الطبيعة مع جولة موجهة عبر الأهوار.",
							"المشاركة في جلسة تأمل للاسترخاء والاسترخاء.",
							"الاستمتاع بعشاء لذيذ محضر بنكهات محلية.",
						],
					},
					day2: {
						title: "العافية والرحيل",
						activities: [
							"ابدأ يومك بجلسة يوغا مجددة بجوار الأهوار.",
							"تناول وجبة إفطار مغذية لبدء يومك.",
							"تجربة جلسة سبا أو تدليك للاسترخاء النهائي.",
							"المشاركة في ورشة عمل لتصوير الطبيعة أو نشاط مشاهدة الطيور.",
							"اختتم إقامتك بالغداء الصحي.",
							"التسجيل والرحيل برغم الهدوء والروح المنعشة.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 3001,
				userName: "ديفيد جونسون",
				userGuideRate: 4,
				comment:
					"قدم حربي رحلة فريدة ومثيرة من خلال العراق. هذا الدليل كان متخصصًا، ودودًا، وجعل التجربة فريدة حقًا. أنا أوصي بخدماته بشدة.",
			},
			{
				userId: 3002,
				userName: "ايما ديفيس",
				userGuideRate: 5,
				comment:
					"قدمت إرشادات حربي رحلتي إلى العراق استثنائية. المعرفة العميقة بالثقافة والتاريخ، جنبًا إلى جنب مع العقلانية والترحيب الحار، خلقت تجربة لا تُنسى. أنا ممتن لخبرة حربي وأوصي به بشدة كدليل.",
			},
			{
				userId: 3003,
				userName: "مايكل سميث",
				userGuideRate: 3,
				comment:
					"كان حربي مرشدنا خلال رحلتنا إلى العراق. في حين كانت الرحلة مثيرة، يمكن تحسين مهارات التواصل والتنظيم لديه. على الرغم من بعض العثرات، قدرنا الجهود والتحليلات التي قدمها حربي حول الحياة المحلية.",
			},
			{
				userId: 3003,
				userName: "مايكل سميث",
				userGuideRate: 3,
				comment:
					"كان حربي مرشدنا خلال رحلتنا إلى العراق. في حين كانت الرحلة مثيرة، يمكن تحسين مهارات التواصل والتنظيم لديه. على الرغم من بعض العثرات، قدرنا الجهود والتحليلات التي قدمها حربي حول الحياة المحلية.",
			},
		],
		GuideInfo: [
			{
				title: "سأري لك",
				description:
					"ستستكشف الجواهر الخفية والمعالم الرمزية، وتستمتع بالمأكولات العراقية التقليدية، وتشارك في المهرجانات الثقافية معي",
			},
			{
				title: "عني",
				description: `مرحبًا، أنا حربي، مرشدك إلى شوارع البصرة النابضة بالحياة. استعد لرحلة لا تُنسى مليئة بالتاريخ الغني واللذائذ الثقافية`,
			},
			{
				title: "اللغات",
				description: ["العربية", "، الإنجليزية"],
			},
			{
				title: "الأنشطة",
				description: [
					"رياضة المشي",
					"، مغامرات في الطهي",
					"، استكشاف الأسواق",
					"، المهرجانات المحلية",
					"، التخييم",
				],
			},
		],
	},
	// 4 Nuha
	{
		idGuide: 4,
		image: nuha,
		imgCover: baghdad,
		name: "نهي م",
		province: " بغداد ",
		perHour: 50,
		rate: 5,
		noOfReviews: 4,
		Quote: "رحلة عبر أرض الآلاف من القصص، سافر إلى العراق",
		ProgramsData: [
			{
				id: 401,
				image: image1,
				name: "رمال بلاد ما بين النهرين",
				describe:
					"استكشاف المناظر الصحراوية القديمة وعجائب بلاد ما بين النهرين الأثري",
				cost: 370,
				duration: 3,
				startDate: "1659474000",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"يعد اليوم الثاني تجربة ثقافية غامرة بينما تستمر رحلتك في عجائب ما بين النهرين التاريخية.",
							"المشاركة في أنشطة ثقافية متنوعة وتجارب، مكتسبة رؤى حول تقاليد المنطقة.",
							"هذا اليوم فرصة للتواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"في اليوم النهائي من مغامرتك، استكشف أي مواقع أثرية متبقية، مضمنًا جوهر المناظر الصحراوية.",
							"تخصيص وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"تختتم الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"بعد ذلك، انطلق في رحلتك التالية، حاملًا ذكريات بلاد ما بين النهرين معك.",
						],
					},
				},
			},
			{
				id: 402,
				image: image1,
				name: "مسار اكتشاف كوردستان",
				describe:
					"انغمس في الثقافة الغنية والمناظر الطبيعية الرائعة لإقليم كوردستان",
				cost: 400,
				duration: 4,
				startDate: "1701550800",
				schedule: {
					day1: {
						title: "الوصول والتعريف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف منطقة كوردستان.",
							"التمتع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "التغمر الثقافي",
						activities: [
							"مواصلة الرحلة من خلال عجائب التاريخ.",
							"المشاركة في أنشطة وتجارب ثقافية.",
							"التواصل مع المجتمعات المحلية والتعرف على تقاليدها.",
						],
					},
					day3: {
						title: "الطبيعة والمغامرة",
						activities: [
							"استكشاف الجمال الطبيعي لمناظر كوردستان.",
							"المشاركة في الأنشطة والمغامرات في الهواء الطلق.",
							"التمتع بالتنوع البيئي الفريد وثقافة المجتمع المحلي النابضة بالحياة.",
						],
					},
					day4: {
						title: "وداعًا والرحيل",
						activities: [
							"انهاء مغامرتك بفعالية وداع.",
							"الرحيل في رحلتك التالية مع ذكريات عزيزة لمسار اكتشاف كوردستان.",
						],
					},
				},
			},
			{
				id: 403,
				image: image1,
				name: "بعثة تراث بغداد",
				describe:
					"اكتشاف الكنوز التاريخية والثقافة النابضة لعاصمة العراق",
				cost: 200,
				duration: 4,
				startDate: "1696885200",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"مواصلة رحلتك من خلال عجائب التاريخ في بلاد ما بين النهرين.",
							"المشاركة في أنشطة ثقافية وتجارب متنوعة.",
							"التواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"استكشاف أي مواقع أثرية متبقية، ملتقطًا جوهر المناظر الصحراوية.",
							"اخذ وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"اختتام الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"الرحيل في رحلتك التالية، حاملًا معك ذكريات بلاد ما بين النهرين.",
						],
					},
					day4: {
						title: "الرحيل",
						activities: [
							"التسجيل من مكان الإقامة الخاص بك.",
							"التأمل في التجارب والذكريات التي تم إنشاؤها خلال الرحلة.",
							"الرحيل في رحلتك التالية.",
						],
					},
				},
			},
			{
				id: 404,
				image: image1,
				name: "ملاذ هدوء الأهوار",
				describe:
					"انغمس في جمال السكون في أهوار العراق، واستمتع بتجربة النظام البيئي الفريد والثقافة المحلية النابضة بالحياة",
				cost: 200,
				duration: 2,
				startDate: "1686344400",
				schedule: {
					day1: {
						title: "الوصول والتغمر في الطبيعة",
						activities: [
							"الوصول إلى موقع الملاذ الهادئ المحاط بالأهوار.",
							"تسجيل الوصول إلى إقامتك المريحة.",
							"انغمس في الطبيعة مع جولة موجهة عبر الأهوار.",
							"المشاركة في جلسة تأمل للاسترخاء والاسترخاء.",
							"الاستمتاع بعشاء لذيذ محضر بنكهات محلية.",
						],
					},
					day2: {
						title: "العافية والرحيل",
						activities: [
							"ابدأ يومك بجلسة يوغا مجددة بجوار الأهوار.",
							"تناول وجبة إفطار مغذية لبدء يومك.",
							"تجربة جلسة سبا أو تدليك للاسترخاء النهائي.",
							"المشاركة في ورشة عمل لتصوير الطبيعة أو نشاط مشاهدة الطيور.",
							"اختتم إقامتك بالغداء الصحي.",
							"التسجيل والرحيل برغم الهدوء والروح المنعشة.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 4001,
				userName: "ديفيد جيسون",
				userGuideRate: 4,
				comment:
					"قدمت نهى رحلة فريدة ومثيرة عبر العراق. كان هذا المرشد متخصصًا وودودًا وجعل الخبرة فريدة من نوعها. أوصي بشدة بخدماتها.",
			},
			{
				userId: 4002,
				userName: "ايما ديفيس",
				userGuideRate: 5,
				comment:
					"أدى توجيه نهى إلى العراق إلى تجربة استثنائية. المعرفة العميقة بالثقافة والتاريخ، جنبًا إلى جنب مع العملية الودية والترحيبية، خلقت تجربة لا تنسى. أنا ممتن لخبرة نهى وأوصي بها بشدة كمرشد.",
			},
			{
				userId: 4003,
				userName: "مايكل سميث",
				userGuideRate: 3,
				comment:
					"نهى كانت مرشدنا خلال رحلتنا إلى العراق. في حين كانت الرحلة مثيرة، يمكن تحسين مهارات التواصل والتنظيم لدى نهى. على الرغم من بعض الانقطاعات، قدرنا الجهود والرؤى في الحياة المحلية.",
			},
			{
				userId: 4004,
				userName: "مايكل سميث",
				userGuideRate: 3,
				comment:
					"نهى كانت مرشدنا خلال رحلتنا إلى العراق. في حين كانت الرحلة مثيرة، يمكن تحسين مهارات التواصل والتنظيم لدى نهى. على الرغم من بعض الانقطاعات، قدرنا الجهود والرؤى في الحياة المحلية.",
			},
		],
		GuideInfo: [
			{
				title: "سأري لك",
				description:
					"ستستكشف الجواهر الخفية والمعالم الرمزية، وتستمتع بالمأكولات العراقية التقليدية، وتشارك في المهرجانات الثقافية معي",
			},
			{
				title: "عني",
				description: `مرحبًا، أنا نهى، مرشدك إلى شوارع بغداد النابضة بالحياة. استعد لرحلة لا تُنسى مليئة بالتاريخ الغني واللذائذ الثقافية`,
			},
			{
				title: "اللغات",
				description: ["العربية", "، الإنجليزية"],
			},
			{
				title: "الأنشطة",
				description: [
					"رياضة المشي",
					"، مغامرات في الطهي",
					"، استكشاف الأسواق",
					"، المهرجانات المحلية",
					"، التخييم",
				],
			},
		],
	},
	// 5 Yousif
	{
		idGuide: 5,
		image: yousif,
		imgCover: karbala,
		name: "يوسف الفهد",
		province: " كربلاء ",
		perHour: 80,
		rate: 5,
		noOfReviews: 10,
		Quote: "اشعر بروح طقوس كربلاء، رحلة ذات أهمية عميقة.",
		ProgramsData: [
			{
				id: 501,
				image: image1,
				name: "رمال بلاد ما بين النهرين",
				describe:
					"استكشاف المناظر الصحراوية القديمة وعجائب بلاد ما بين النهرين الأثري",
				cost: 370,
				duration: 3,
				startDate: "1705698000",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"يعد اليوم الثاني تجربة ثقافية غامرة بينما تستمر رحلتك في عجائب ما بين النهرين التاريخية.",
							"المشاركة في أنشطة ثقافية متنوعة وتجارب، مكتسبة رؤى حول تقاليد المنطقة.",
							"هذا اليوم فرصة للتواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"في اليوم النهائي من مغامرتك، استكشف أي مواقع أثرية متبقية، مضمنًا جوهر المناظر الصحراوية.",
							"تخصيص وقت تقدير الجمال الذي تقدمه بلاد ما بين النهرين.",
							"تختتم الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"بعد ذلك، انطلق في رحلتك التالية، حاملًا ذكريات بلاد ما بين النهرين معك.",
						],
					},
				},
			},
			{
				id: 502,
				image: image1,
				name: "مسار اكتشاف كوردستان",
				describe:
					"انغمس في الثقافة الغنية والمناظر الطبيعية الرائعة لإقليم كوردستان",
				cost: 400,
				duration: 4,
				startDate: "1703538000",
				schedule: {
					day1: {
						title: "الوصول والتعريف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف منطقة كوردستان.",
							"التمتع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "التغمر الثقافي",
						activities: [
							"مواصلة الرحلة من خلال عجائب التاريخ.",
							"المشاركة في أنشطة وتجارب ثقافية.",
							"التواصل مع المجتمعات المحلية والتعرف على تقاليدها.",
						],
					},
					day3: {
						title: "الطبيعة والمغامرة",
						activities: [
							"استكشاف الجمال الطبيعي لمناظر كوردستان.",
							"المشاركة في الأنشطة والمغامرات في الهواء الطلق.",
							"التمتع بالتنوع البيئي الفريد وثقافة المجتمع المحلي النابضة بالحياة.",
						],
					},
					day4: {
						title: "وداعًا والرحيل",
						activities: [
							"انهاء مغامرتك بفعالية وداع.",
							"الرحيل في رحلتك التالية مع ذكريات عزيزة لمسار اكتشاف كوردستان.",
						],
					},
				},
			},
			{
				id: 503,
				image: image1,
				name: "بعثة تراث بغداد",
				describe:
					"اكتشاف الكنوز التاريخية والثقافة النابضة لعاصمة العراق",
				cost: 200,
				duration: 4,
				startDate: "1644008400",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"مواصلة رحلتك من خلال عجائب التاريخ في بلاد ما بين النهرين.",
							"المشاركة في أنشطة ثقافية وتجارب متنوعة.",
							"التواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"استكشاف أي مواقع أثرية متبقية، ملتقطًا جوهر المناظر الصحراوية.",
							"اخذ وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"اختتام الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"الرحيل في رحلتك التالية، حاملًا معك ذكريات بلاد ما بين النهرين.",
						],
					},
					day4: {
						title: "الرحيل",
						activities: [
							"التسجيل من مكان الإقامة الخاص بك.",
							"التأمل في التجارب والذكريات التي تم إنشاؤها خلال الرحلة.",
							"الرحيل في رحلتك التالية.",
						],
					},
				},
			},
			{
				id: 504,
				image: image1,
				name: "ملاذ هدوء الأهوار",
				describe:
					"انغمس في جمال السكون في أهوار العراق، واستمتع بتجربة النظام البيئي الفريد والثقافة المحلية النابضة بالحياة",
				cost: 200,
				duration: 2,
				startDate: "1707080400",
				schedule: {
					day1: {
						title: "الوصول والتغمر في الطبيعة",
						activities: [
							"الوصول إلى موقع الملاذ الهادئ المحاط بالأهوار.",
							"تسجيل الوصول إلى إقامتك المريحة.",
							"انغمس في الطبيعة مع جولة موجهة عبر الأهوار.",
							"المشاركة في جلسة تأمل للاسترخاء والاسترخاء.",
							"الاستمتاع بعشاء لذيذ محضر بنكهات محلية.",
						],
					},
					day2: {
						title: "العافية والرحيل",
						activities: [
							"ابدأ يومك بجلسة يوغا مجددة بجوار الأهوار.",
							"تناول وجبة إفطار مغذية لبدء يومك.",
							"تجربة جلسة سبا أو تدليك للاسترخاء النهائي.",
							"المشاركة في ورشة عمل لتصوير الطبيعة أو نشاط مشاهدة الطيور.",
							"اختتم إقامتك بالغداء الصحي.",
							"التسجيل والرحيل برغم الهدوء والروح المنعشة.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 5001,
				userName: "ديفيد جونسون",
				userGuideRate: 4,
				comment:
					"قدم يوسف رحلة فريدة ومفيدة عبر العراق. كان هذا المرشد متعلمًا وودودًا، وجعل التجربة فريدة حقًا. أوصي بخدماته بشدة.",
			},
			{
				userId: 5002,
				userName: "ايما ديفيس",
				userGuideRate: 5,
				comment:
					"إرشاد يوسف جعل زيارتي إلى العراق استثنائية. المعرفة العميقة بالثقافة والتاريخ، جنبًا إلى جنب مع الاستقبال الدافئ والودود، خلقت تجربة لا تنسى. أنا ممتن لخبرة يوسف وأوصي به بشدة كمرشد.",
			},
			{
				userId: 5003,
				userName: "مايكل سميث",
				userGuideRate: 3,
				comment:
					"كان يوسف مرشدنا خلال رحلتنا إلى العراق. في حين كانت الرحلة مثيرة، يمكن تحسين مهارات الاتصال والتنظيم لديه. على الرغم من بعض العثرات، قدرنا الجهود والتفاهم في الحياة المحلية.",
			},
		],
		GuideInfo: [
			{
				title: "سأري لك",
				description:
					"ستستكشف الجواهر الخفية والمعالم الرمزية، وتستمتع بالمأكولات العراقية التقليدية، وتشارك في المهرجانات الثقافية معي",
			},
			{
				title: "عني",
				description: `مرحبًا، أنا يوسف، مرشدك إلى شوارع كربلاء النابضة بالحياة. استعد لرحلة لا تُنسى مليئة بالتاريخ الغني واللذائذ الثقافية`,
			},
			{
				title: "اللغات",
				description: [
					"العربية",
					"، الكردية",
					"، الإنجليزية",
				],
			},
			{
				title: "الأنشطة",
				description: [
					"رياضة المشي",
					"، مغامرات في الطهي",
					"، استكشاف الأسواق",
					"، المهرجانات المحلية",
					"، التخييم",
				],
			},
		],
	},
	// 6 Ali
	{
		idGuide: 6,
		image: aliH,
		imgCover: najaf,
		name: "علي حميد",
		province: "بغداد",
		perHour: "20",
		rate: 5,
		noOfReviews: 10,
		Quote:
			"سافر إلى العراق، حيث يلتقي الماضي بالحاضر بتناغم.",
		ProgramsData: [
			{
				id: 601,
				image: image1,
				name: "رمال بلاد ما بين النهرين",
				describe:
					"استكشاف المناظر الصحراوية القديمة وعجائب بلاد ما بين النهرين الأثري",
				cost: 370,
				duration: 3,
				startDate: "1717966800",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"يعد اليوم الثاني تجربة ثقافية غامرة بينما تستمر رحلتك في عجائب ما بين النهرين التاريخية.",
							"المشاركة في أنشطة ثقافية متنوعة وتجارب، مكتسبة رؤى حول تقاليد المنطقة.",
							"هذا اليوم فرصة للتواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"في اليوم النهائي من مغامرتك، استكشف أي مواقع أثرية متبقية، مضمنًا جوهر المناظر الصحراوية.",
							"تخصيص وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"تختتم الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"بعد ذلك، انطلق في رحلتك التالية، حاملًا ذكريات بلاد ما بين النهرين معك.",
						],
					},
				},
			},
			{
				id: 602,
				image: image1,
				name: "مسار اكتشاف كوردستان",
				describe:
					"انغمس في الثقافة الغنية والمناظر الطبيعية الرائعة لإقليم كوردستان",
				cost: 400,
				duration: 4,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "الوصول والتعريف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف منطقة كوردستان.",
							"التمتع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "التغمر الثقافي",
						activities: [
							"مواصلة الرحلة من خلال عجائب التاريخ.",
							"المشاركة في أنشطة وتجارب ثقافية.",
							"التواصل مع المجتمعات المحلية والتعرف على تقاليدها.",
						],
					},
					day3: {
						title: "الطبيعة والمغامرة",
						activities: [
							"استكشاف الجمال الطبيعي لمناظر كوردستان.",
							"المشاركة في الأنشطة والمغامرات في الهواء الطلق.",
							"التمتع بالتنوع البيئي الفريد وثقافة المجتمع المحلي النابضة بالحياة.",
						],
					},
					day4: {
						title: "وداعًا والرحيل",
						activities: [
							"انهاء مغامرتك بفعالية وداع.",
							"الرحيل في رحلتك التالية مع ذكريات عزيزة لمسار اكتشاف كوردستان.",
						],
					},
				},
			},
			{
				id: 603,
				image: image1,
				name: "بعثة تراث بغداد",
				describe:
					"اكتشاف الكنوز التاريخية والثقافة النابضة لعاصمة العراق",
				cost: 200,
				duration: 4,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"مواصلة رحلتك من خلال عجائب التاريخ في بلاد ما بين النهرين.",
							"المشاركة في أنشطة ثقافية وتجارب متنوعة.",
							"التواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"استكشاف أي مواقع أثرية متبقية، ملتقطًا جوهر المناظر الصحراوية.",
							"اخذ وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"اختتام الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"الرحيل في رحلتك التالية، حاملًا معك ذكريات بلاد ما بين النهرين.",
						],
					},
					day4: {
						title: "الرحيل",
						activities: [
							"التسجيل من مكان الإقامة الخاص بك.",
							"التأمل في التجارب والذكريات التي تم إنشاؤها خلال الرحلة.",
							"الرحيل في رحلتك التالية.",
						],
					},
				},
			},
			{
				id: 604,
				image: image1,
				name: "ملاذ هدوء الأهوار",
				describe:
					"انغمس في جمال السكون في أهوار العراق، واستمتع بتجربة النظام البيئي الفريد والثقافة المحلية النابضة بالحياة",
				cost: 200,
				duration: 2,
				startDate: "1734296400",
				schedule: {
					day1: {
						title: "الوصول والتغمر في الطبيعة",
						activities: [
							"الوصول إلى موقع الملاذ الهادئ المحاط بالأهوار.",
							"تسجيل الوصول إلى إقامتك المريحة.",
							"انغمس في الطبيعة مع جولة موجهة عبر الأهوار.",
							"المشاركة في جلسة تأمل للاسترخاء والاسترخاء.",
							"الاستمتاع بعشاء لذيذ محضر بنكهات محلية.",
						],
					},
					day2: {
						title: "العافية والرحيل",
						activities: [
							"ابدأ يومك بجلسة يوغا مجددة بجوار الأهوار.",
							"تناول وجبة إفطار مغذية لبدء يومك.",
							"تجربة جلسة سبا أو تدليك للاسترخاء النهائي.",
							"المشاركة في ورشة عمل لتصوير الطبيعة أو نشاط مشاهدة الطيور.",
							"اختتم إقامتك بالغداء الصحي.",
							"التسجيل والرحيل برغم الهدوء والروح المنعشة.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 6001,
				userName: "ديفيد جونسون",
				userGuideRate: 4,
				comment:
					"قدم علي رحلة فريدة ومفيدة عبر العراق. كان هذا المرشد متعلمًا وودودًا، وجعل الخبرة فريدة حقًا. أوصي بشدة بخدماتهم.",
			},
			{
				userId: 6002,
				userName: "ايما ديفيس",
				userGuideRate: 5,
				comment:
					"أدلى الي رحلتي إلى العراق استثنائية. المعرفة العميقة بالثقافة والتاريخ، جنبًا إلى جنب مع العقلانية والترحيب الحار، خلقت تجربة لا تنسى. أنا ممتن لخبرة علي وأوصي بها بشدة كمرشد.",
			},
			{
				userId: 6003,
				userName: "مايكل سميث",
				userGuideRate: 3,
				comment:
					"كان علي مرشدنا خلال رحلتنا إلى العراق. في حين كانت الرحلة مثيرة، يمكن تحسين مهارات التواصل والتنظيم لديه. على الرغم من بعض العراقيل، قدرنا الجهود والتحليلات في الحياة المحلية.",
			},
		],
		GuideInfo: [
			{
				title: "سأري لك",
				description:
					"ستستكشف الجواهر الخفية والمعالم الرمزية، وتستمتع بالمأكولات العراقية التقليدية، وتشارك في المهرجانات الثقافية معي",
			},
			{
				title: "عني",
				description: `مرحبًا، أنا علي، مرشدك إلى شوارع بغداد النابضة بالحياة. استعد لرحلة لا تُنسى مليئة بالتاريخ الغني واللذائذ الثقافية`,
			},
			{
				title: "اللغات",
				description: [
					"العربية",
					"، الكردية",
					"، الإنجليزية",
				],
			},
			{
				title: "الأنشطة",
				description: [
					"رياضة المشي",
					"، مغامرات في الطهي",
					"، استكشاف الأسواق",
					"، المهرجانات المحلية",
					"، التخييم",
				],
			},
		],
	},
	// 7 Lubna
	{
		idGuide: 7,
		image: lubna,
		imgCover: kurdistan,
		name: "لبنى صادق",
		province: "سليمانية",
		perHour: "40",
		rate: 3.5,
		noOfReviews: 13,
		Quote: "استمتع بدفء الضيافة العراقية، رحلة لا مثيل لها",
		ProgramsData: [
			{
				id: 701,
				image: image1,
				name: "رمال بلاد ما بين النهرين",
				describe:
					"استكشاف المناظر الصحراوية القديمة وعجائب بلاد ما بين النهرين الأثري",
				cost: 370,
				duration: 3,
				startDate: "1659474000",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"يعد اليوم الثاني تجربة ثقافية غامرة بينما تستمر رحلتك في عجائب ما بين النهرين التاريخية.",
							"المشاركة في أنشطة ثقافية متنوعة وتجارب، مكتسبة رؤى حول تقاليد المنطقة.",
							"هذا اليوم فرصة للتواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"في اليوم النهائي من مغامرتك، استكشف أي مواقع أثرية متبقية، مضمنًا جوهر المناظر الصحراوية.",
							"تخصيص وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"تختتم الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"بعد ذلك، انطلق في رحلتك التالية، حاملًا ذكريات بلاد ما بين النهرين معك.",
						],
					},
				},
			},
			{
				id: 702,
				image: image1,
				name: "مسار اكتشاف كوردستان",
				describe:
					"انغمس في الثقافة الغنية والمناظر الطبيعية الرائعة لإقليم كوردستان",
				cost: 400,
				duration: 4,
				startDate: "1701550800",
				schedule: {
					day1: {
						title: "الوصول والتعريف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف منطقة كوردستان.",
							"التمتع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "التغمر الثقافي",
						activities: [
							"مواصلة الرحلة من خلال عجائب التاريخ.",
							"المشاركة في أنشطة وتجارب ثقافية.",
							"التواصل مع المجتمعات المحلية والتعرف على تقاليدها.",
						],
					},
					day3: {
						title: "الطبيعة والمغامرة",
						activities: [
							"استكشاف الجمال الطبيعي لمناظر كوردستان.",
							"المشاركة في الأنشطة والمغامرات في الهواء الطلق.",
							"التمتع بالتنوع البيئي الفريد وثقافة المجتمع المحلي النابضة بالحياة.",
						],
					},
					day4: {
						title: "وداعًا والرحيل",
						activities: [
							"انهاء مغامرتك بفعالية وداع.",
							"الرحيل في رحلتك التالية مع ذكريات عزيزة لمسار اكتشاف كوردستان.",
						],
					},
				},
			},
			{
				id: 703,
				image: image1,
				name: "بعثة تراث بغداد",
				describe:
					"اكتشاف الكنوز التاريخية والثقافة النابضة لعاصمة العراق",
				cost: 200,
				duration: 4,
				startDate: "1696885200",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"مواصلة رحلتك من خلال عجائب التاريخ في بلاد ما بين النهرين.",
							"المشاركة في أنشطة ثقافية وتجارب متنوعة.",
							"التواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"استكشاف أي مواقع أثرية متبقية، ملتقطًا جوهر المناظر الصحراوية.",
							"اخذ وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"اختتام الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"الرحيل في رحلتك التالية، حاملًا معك ذكريات بلاد ما بين النهرين.",
						],
					},
					day4: {
						title: "الرحيل",
						activities: [
							"التسجيل من مكان الإقامة الخاص بك.",
							"التأمل في التجارب والذكريات التي تم إنشاؤها خلال الرحلة.",
							"الرحيل في رحلتك التالية.",
						],
					},
				},
			},
			{
				id: 704,
				image: image1,
				name: "ملاذ هدوء الأهوار",
				describe:
					"انغمس في جمال السكون في أهوار العراق، واستمتع بتجربة النظام البيئي الفريد والثقافة المحلية النابضة بالحياة",
				cost: 200,
				duration: 2,
				startDate: "1686344400",
				schedule: {
					day1: {
						title: "الوصول والتغمر في الطبيعة",
						activities: [
							"الوصول إلى موقع الملاذ الهادئ المحاط بالأهوار.",
							"تسجيل الوصول إلى إقامتك المريحة.",
							"انغمس في الطبيعة مع جولة موجهة عبر الأهوار.",
							"المشاركة في جلسة تأمل للاسترخاء والاسترخاء.",
							"الاستمتاع بعشاء لذيذ محضر بنكهات محلية.",
						],
					},
					day2: {
						title: "العافية والرحيل",
						activities: [
							"ابدأ يومك بجلسة يوغا مجددة بجوار الأهوار.",
							"تناول وجبة إفطار مغذية لبدء يومك.",
							"تجربة جلسة سبا أو تدليك للاسترخاء النهائي.",
							"المشاركة في ورشة عمل لتصوير الطبيعة أو نشاط مشاهدة الطيور.",
							"اختتم إقامتك بالغداء الصحي.",
							"التسجيل والرحيل برغم الهدوء والروح المنعشة.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 7001,
				userName: "ديفيد جونسون",
				userGuideRate: 4,
				comment:
					"قدمت لبنى رحلة فريدة ومفيدة في العراق. كانت هذه الدليلة متعلمة وودودة، وجعلت التجربة فريدة حقًا. أوصي بخدماتها بشدة.",
			},
			{
				userId: 7002,
				userName: "ايما ديفيس",
				userGuideRate: 5,
				comment:
					"قدمت لبنى رحلة إلى العراق استثنائية. المعرفة العميقة بالثقافة والتاريخ، جنبًا إلى جنب مع الطابع الودود والترحيبي، خلقت تجربة لا تُنسى. أنا ممتن لخبرة لبنى وأوصي بها بشدة كدليلة.",
			},
			{
				userId: 7003,
				userName: "مايكل سميث",
				userGuideRate: 3,
				comment:
					"لبنى كانت مرشدتنا خلال رحلتنا إلى العراق. في حين كانت الرحلة مثيرة للاهتمام، يمكن تحسين مهارات التواصل والتنظيم لديها. على الرغم من بعض العراقيل، قدرنا الجهود والتحليلات التي قدمتها حول الحياة المحلية.",
			},
		],
		GuideInfo: [
			{
				title: "سأري لك",
				description:
					"ستستكشف الجواهر الخفية والمعالم الرمزية، وتستمتع بالمأكولات العراقية التقليدية، وتشارك في المهرجانات الثقافية معي",
			},
			{
				title: "عني",
				description: `مرحبًا، أنا لبنى، مرشدك إلى شوارع السليمانية النابضة بالحياة. استعد لرحلة لا تُنسى مليئة بالتاريخ الغني واللذائذ الثقافية`,
			},
			{
				title: "اللغات",
				description: [
					"العربية",
					"، الكردية",
					"، الإنجليزية",
				],
			},
			{
				title: "الأنشطة",
				description: [
					"رياضة المشي",
					"، مغامرات في الطهي",
					"، استكشاف الأسواق",
					"، المهرجانات المحلية",
					"، التخييم",
				],
			},
		],
	},
	// 8 Hussein
	{
		idGuide: 8,
		image: hussein,
		imgCover: anbar,
		name: "حسين راشد",
		province: " الانبار ",
		perHour: "15",
		rate: 5,
		noOfReviews: 10,
		Quote:
			"العراق، فسيفساء من الثقافات في انتظار الاستكشاف",
		ProgramsData: [
			{
				id:801,
				image: image1,
				name: "رمال بلاد ما بين النهرين",
				describe:
					"استكشاف المناظر الصحراوية القديمة وعجائب بلاد ما بين النهرين الأثري",
				cost: 370,
				duration: 3,
				startDate: "1703019600",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"يعد اليوم الثاني تجربة ثقافية غامرة بينما تستمر رحلتك في عجائب ما بين النهرين التاريخية.",
							"المشاركة في أنشطة ثقافية متنوعة وتجارب، مكتسبة رؤى حول تقاليد المنطقة.",
							"هذا اليوم فرصة للتواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"في اليوم النهائي من مغامرتك، استكشف أي مواقع أثرية متبقية، مضمنًا جوهر المناظر الصحراوية.",
							"تخصيص وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"تختتم الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"بعد ذلك، انطلق في رحلتك التالية، حاملًا ذكريات بلاد ما بين النهرين معك.",
						],
					},
				},
			},
			{
				id: 802,
				image: image1,
				name: "مسار اكتشاف كوردستان",
				describe:
					"انغمس في الثقافة الغنية والمناظر الطبيعية الرائعة لإقليم كوردستان",
				cost: 400,
				duration: 4,
				startDate: "1729026000",
				schedule: {
					day1: {
						title: "الوصول والتعريف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف منطقة كوردستان.",
							"التمتع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "التغمر الثقافي",
						activities: [
							"مواصلة الرحلة من خلال عجائب التاريخ.",
							"المشاركة في أنشطة وتجارب ثقافية.",
							"التواصل مع المجتمعات المحلية والتعرف على تقاليدها.",
						],
					},
					day3: {
						title: "الطبيعة والمغامرة",
						activities: [
							"استكشاف الجمال الطبيعي لمناظر كوردستان.",
							"المشاركة في الأنشطة والمغامرات في الهواء الطلق.",
							"التمتع بالتنوع البيئي الفريد وثقافة المجتمع المحلي النابضة بالحياة.",
						],
					},
					day4: {
						title: "وداعًا والرحيل",
						activities: [
							"انهاء مغامرتك بفعالية وداع.",
							"الرحيل في رحلتك التالية مع ذكريات عزيزة لمسار اكتشاف كوردستان.",
						],
					},
				},
			},
			{
				id: 803,
				image: image1,
				name: "بعثة تراث بغداد",
				describe:
					"اكتشاف الكنوز التاريخية والثقافة النابضة لعاصمة العراق",
				cost: 200,
				duration: 4,
				startDate: "1733173200",
				schedule: {
					day1: {
						title: "الوصول والاستكشاف",
						activities: [
							"الوصول إلى نقطة البداية المحددة.",
							"التعرف على زملائك المسافرين ومرشدك.",
							"بدء استكشاف المناظر الصحراوية القديمة.",
							"زيارة المواقع الأثرية الرئيسية.",
							"الاستمتاع بعشاء ترحيبي.",
						],
					},
					day2: {
						title: "تجربة ثقافية غامرة",
						activities: [
							"مواصلة رحلتك من خلال عجائب التاريخ في بلاد ما بين النهرين.",
							"المشاركة في أنشطة ثقافية وتجارب متنوعة.",
							"التواصل مع المجتمعات المحلية، مع تعزيز فهم أعماق التاريخ الذي يحيط بك.",
						],
					},
					day3: {
						title: "اكتشافات نهائية والرحيل",
						activities: [
							"استكشاف أي مواقع أثرية متبقية، ملتقطًا جوهر المناظر الصحراوية.",
							"اخذ وقت لapprciate الجمال الذي تقدمه بلاد ما بين النهرين.",
							"اختتام الرحلة بفعالية وداع، وتوفير ختام مناسب لاستكشافك.",
							"الرحيل في رحلتك التالية، حاملًا معك ذكريات بلاد ما بين النهرين.",
						],
					},
					day4: {
						title: "الرحيل",
						activities: [
							"التسجيل من مكان الإقامة الخاص بك.",
							"التأمل في التجارب والذكريات التي تم إنشاؤها خلال الرحلة.",
							"الرحيل في رحلتك التالية.",
						],
					},
				},
			},
			{
				id: 804,
				image: image1,
				name: "ملاذ هدوء الأهوار",
				describe:
					"انغمس في جمال السكون في أهوار العراق، واستمتع بتجربة النظام البيئي الفريد والثقافة المحلية النابضة بالحياة",
				cost: 200,
				duration: 2,
				startDate: "1681938000",
				schedule: {
					day1: {
						title: "الوصول والتغمر في الطبيعة",
						activities: [
							"الوصول إلى موقع الملاذ الهادئ المحاط بالأهوار.",
							"تسجيل الوصول إلى إقامتك المريحة.",
							"انغمس في الطبيعة مع جولة موجهة عبر الأهوار.",
							"المشاركة في جلسة تأمل للاسترخاء والاسترخاء.",
							"الاستمتاع بعشاء لذيذ محضر بنكهات محلية.",
						],
					},
					day2: {
						title: "العافية والرحيل",
						activities: [
							"ابدأ يومك بجلسة يوغا مجددة بجوار الأهوار.",
							"تناول وجبة إفطار مغذية لبدء يومك.",
							"تجربة جلسة سبا أو تدليك للاسترخاء النهائي.",
							"المشاركة في ورشة عمل لتصوير الطبيعة أو نشاط مشاهدة الطيور.",
							"اختتم إقامتك بالغداء الصحي.",
							"التسجيل والرحيل برغم الهدوء والروح المنعشة.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 8001,
				userName: "سميث جونسون",
				userGuideRate: 3.5,
				comment:
					"قام حسين بتوفير رحلة فريدة ومثيرة من خلال العراق. كان هذا المرشد متخصصًا وودودًا وجعل التجربة فريدة حقًا. أوصي بخدماته بشدة.",
			},
			{
				userId: 8002,
				userName: "ايما واتسون",
				userGuideRate: 5,
				comment:
					"قامت إرشادات حسين بجعل زيارتي إلى العراق استثنائية. المعرفة العميقة بالثقافة والتاريخ، بالإضافة إلى العقلانية والترحيب، خلقت تجربة لا تنسى. أنا ممتن لخبرة حسين وأوصي به بشدة كمرشد.",
			},
			{
				userId: 8003,
				userName: "مورفي كريس",
				userGuideRate: 2,
				comment:
					"كان حسين مرشدنا خلال رحلتنا إلى العراق. بينما كانت الرحلة مثيرة، يمكن تحسين مهارات التواصل والتنظيم لديه. على الرغم من بعض العقبات، قدرنا الجهود والتفاهم في التعرف على الحياة المحلية.",
			},
		],
		GuideInfo: [
			{
				title: "سأري لك",
				description:
					"ستستكشف الجواهر الخفية والمعالم الرمزية، وتستمتع بالمأكولات العراقية التقليدية، وتشارك في المهرجانات الثقافية معي",
			},
			{
				title: "عني",
				description: `مرحبًا، أنا حسين، مرشدك إلى شوارع الأنبار النابضة بالحياة. استعد لرحلة لا تُنسى مليئة بالتاريخ الغني واللذائذ الثقافية`,
			},
			{
				title: "اللغات",
				description: ["العربية"],
			},
			{
				title: "الأنشطة",
				description: [
					"رياضة المشي",
					"، مغامرات في الطهي",
					"، استكشاف الأسواق",
					"، المهرجانات المحلية",
					"، التخييم",
				],
			},
		],
	},
];

export default GuideData;
